/**
 * Durable navigation links for public intent guides (PBI #1318).
 * Used by PublicNav and PublicFooter so guides stay discoverable.
 */

import { PUBLIC_ROUTES } from './routes';
import { AI_PUBLIC_ROUTES } from './aiPublicRoutes';

export interface PublicGuideNavItem {
  key: string;
  label: string;
  path: string;
}

/**
 * Guide links for header, mobile drawer, and footer.
 * Pass false to hide the AI hub while Features:PublicAiPage is off.
 */
export function visiblePublicGuideNavItems(
  publicAiPageEnabled: boolean,
): readonly PublicGuideNavItem[] {
  if (publicAiPageEnabled) {
    return PUBLIC_GUIDE_NAV_ITEMS;
  }

  return PUBLIC_GUIDE_NAV_ITEMS.filter((item) => item.key !== 'ai');
}

/** Indexable guides linked from header/footer (not the full /ai use-case tree). */
export const PUBLIC_GUIDE_NAV_ITEMS: readonly PublicGuideNavItem[] = [
  {
    key: 'guides',
    label: 'Guides',
    path: PUBLIC_ROUTES.guides,
  },
  {
    key: 'ai',
    label: 'AI',
    path: AI_PUBLIC_ROUTES.hub,
  },
];
